import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../lib/firebase';

export function useTenantCollection(name, tenantId, enabled = true) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(Boolean(enabled && tenantId));
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || !tenantId || tenantId === 'super_admin') { setItems([]); setLoading(false); return undefined; }
    setLoading(true);
    const q = query(collection(db, name), where('tenantId', '==', tenantId));
    return onSnapshot(q, snap => {
      setItems(snap.docs.map(item => ({ id: item.id, ...item.data() })));
      setLoading(false);
    }, err => { setError(err); setLoading(false); });
  }, [name, tenantId, enabled]);

  return { items, loading, error };
}
